module.exports = __webpack_public_path__ + "static/img/奖2.bf5322b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/奖2.png
// module id = 431
// module chunks = 2